// Track social link clicks

function trackSocialClick(appUrl) {
  try {
    sensors.track('SocialLinkClick', {
      social_link: appUrl,
    });
  } catch (error) {
    console.error('Error tracking social click:', error);
  }
}

// Track app download clicks
function trackAppDownload(downloadUrl) {
  try {
    sensors.track('DownloadAPP', {
      download_channel: downloadUrl,
    });
  } catch (error) {
    console.error('Error tracking app download:', error);
  }
}

function trackWebLoginPageView() {
  try {
    sensors.track('WebLoginPageView', {
      current_url: window.location.herf,
      referrer: window.renogyConfig.login_url,
    });
  } catch (error) {
    console.error('Error tracking web login:', error);
  }
}

function CommodityDetailPageview(product) {
  console.log("sensors",sensors);
  console.log("product:", product);
  try {
    const is_range_commodity = (product.priceMin === product.priceMax) ? false : true;
    sensors.track('CommodityDetailPageview', {
      commodity_id: product.productId,
      commodity_sku: product.productSku,
      commodity_name: product.productName,
      now_price_range: '{{product.priceMin}}~{{product.priceMax}}',
      was_price_range: '',
      is_on_sale: true,
      is_stockout: !product.available,
      page_resource: this.window.herf,
      is_range_commodity,
    });
    if (product.productUrl || product.productUrl != '') CommodityClick(product);
  } catch (error) {
    console.log('error:', error);
  }
}

function BottomNavigationClick(href) {
  sensors.track('BottomNavigationClick', {
    first_menu: href,
    page_resource: this.window.herf,
    second_menu: '',
  })
}

function CommodityClick(product) {
  const is_range_commodity = (product.priceMin === product.priceMax) ? false : true;
  sensors.track('CommodityClick', {
    click_method: 'click',
    commodity_id: product.productId,
    commodity_name: product.productName,
    commodity_sku: product.productSku,
    commodity_url: product.productUrl,
    current_page: this.window.herf,
    device_sn: '',
    is_on_sale: true,
    is_range_commodity,
    is_stockout: !product.available,
    now_price_range: '{{product.priceMin}}~{{product.priceMax}}',
    position_number: '',
    was_price_range: '',
  })
}

function CommodityCompare(product) {
  // const is_stockout = ($parentElement.find('.btn-ProductActionAdd').text().indexOf('Sold Out') > -1) ? true : false;
  try {
    sensors.track('CommodityCompare', {
      commodity_id: product.productId,
      commodity_name: product.productName,
      commodity_sku: product.sku,
      is_on_sale: true,
      is_stockout: false,
    });
  } catch (error) {
    console.log('commodity error:', error)
  }
}

function trackTopNavigationClick(href) {
  try {
    sensors.track("TopNavigationClick", {
      first_menu: href,
    })
  } catch (error) {
    console.log("error:", error)
  }
}

function trackBundleItemChoose(bundleId) {
  try {
    sensors.track('BundleItemChoose', {
      chosseType: '',
      commodity_id: bundleId,
      recommedCommodity_id: '',
    });
  } catch (error) {
    console.log('track bundle Item error:', error);
  }
}

function trackSkuOption(product) {
  try {
    sensors.track('SkuOption', {
      commodity_id: product.optionId,
      commodity_name: product.optionName,
      commodity_sku: product.optionSku,
    })
  } catch (error) {
    console.log('track sku option error:', error);
  }
}

function trackMailSubscribe(id) {
  try {
    const email = document.getElementById(id).value;
    sensors.track('MailSubscribe', {
      email,
    })
    console.log('success')
  } catch (error) {
    console.log('mail subscribe error:', error);
  }
}

function trackCheckoutClick(cartId) {
  try {
    sensors.track('checkoutClick', {
      cartId: '',
    })
  } catch (error) {
    console.log('checkout click error:', error);
  }
}

function HomepageModuleClick() {
  try {
    sensors.track('HomepageModuleClick', {
      foward_url: this.window.href,
      module_inner_id: '',
      module_inner_name: '',
      module_inner_rank: '',
      module_inner_type: '',
      module_name: '',
      module_rank: '',
    })
  } catch (error) {
    console.log('track HomePageModuleClick error:', error);
  }
}

function AddToCart(productId) {
  try {
    sensors.track('AddToCart', {
      cartId: '',
      commodity_id: productId,
      commodity_quantity: 1,
      current_page: window.location.href,
      is_free_shipping: true,
    });
    sensors.track('CartIdConnection', {
      cartId: '',
    })
  } catch (error) {
    console.log('add cart error', error);
  }
}

function SearchBoxClick(){
  try {
    sensors.track('SearchBoxClick', {
      current_page: window.location.href,
    })
  } catch (error) {
    console.log('search box click error:', error);
  }
}
